import { useEffect, useState } from 'react';
import { GIC_LIFECYCLE_EVENTS } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/constants.tsx';
import { useGICLifeCycleEvents } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/main.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

export const useDescriptionAnalytics = () => {
	const { subscribe } = useGICLifeCycleEvents();
	const [hasSent, setHasSent] = useState(false);

	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		const unsubscribeFromChange = subscribe(
			GIC_LIFECYCLE_EVENTS.CREATE_FORM_FIELD_VALUE_CHANGE,
			(data: { fieldId: string }) => {
				if (!hasSent && data.fieldId === 'description') {
					const analyticsEvent = createAnalyticsEvent({
						actionSubject: 'description',
						action: 'editStarted',
					});
					fireUIAnalytics(analyticsEvent, 'createIssueDescriptionTouched');
					setHasSent(true);
				}
			},
		);

		const unsubscribeFromBlur = subscribe(
			GIC_LIFECYCLE_EVENTS.CREATE_FORM_FIELD_BLUR,
			(data: { fieldId: string }) => {
				if (data.fieldId === 'description') {
					setHasSent(false);
				}
			},
		);

		return () => {
			unsubscribeFromChange();
			unsubscribeFromBlur();
		};
	}, [createAnalyticsEvent, subscribe, hasSent, setHasSent]);
};
